import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import TrustboxEmbed from '../../components/embeds/TrustboxEmbed';

@connect(({channels}) => ({activeLocale: channels.activeLocale}), {})
export default class TrustboxContainer extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired
  };

  static trustboxTypes = {
    micro: {
      templateId: process.env.TRUSTPILOT_WIDGET_MICRO_ID,
      height: '20px',
      theme: 'dark'
    },
    carousel: {
      templateId: process.env.TRUSTPILOT_WIDGET_CAROUSEL_ID,
      stars: '3,4,5',
      height: '220px',
      theme: 'dark'
    },
    grid: {
      templateId: process.env.TRUSTPILOT_WIDGET_GRID_ID,
      stars: '3,4,5',
      schemaType: 'Organization',
      height: '1400px',
      theme: 'dark'
    }
  };

  render() {
    const {activeLocale, type, ...rest} = this.props;

    return (
      <TrustboxEmbed
        locale={activeLocale ? activeLocale.replace('_', '-') : 'en-US'}
        domain={process.env.TRUSTPILOT_DOMAIN}
        businessUnitId={process.env.TRUSTPILOT_BUSINESS_UNIT_ID}
        width="100%"
        {...TrustboxContainer.trustboxTypes[type]}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./containers/trustboxContainer/TrustboxContainer.js